enum PlayerIbansStatusType {
  REJECTED = 'REJECTED',
  PENDING_VERIFICATION = 'PENDING_VERIFICATION',
  VERIFIED = 'VERIFIED',
  NO_DOCUMENT = 'NO_DOCUMENT',
}

export default PlayerIbansStatusType
